import React, { useEffect, useState } from "react";
import Chart from "chart.js/auto"; // Import Chart.js
import environmentVariables from "../../../config/environmentVariables";
import axios from "axios";
import { useParams } from "react-router";
const ActivityTableGraph = ({ nftData }) => {
  const params = useParams();
  // const [conversionRateMLD, setConversionRateMLD] = useState(null);
  // const [conversionRateLord, setConversionRateLord] = useState(null);
  // const [conversionRateMatic, setConversionRateMatic] = useState(null);
  // const [conversionRateUSDT, setConversionRateUSDT] = useState(null);
  const [labels, setLabels] = useState([]);
  const [prices, setPrices] = useState([]);
  const getConversionRates = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_graph_data/${params.contract}/${params.tokenId}`
      )
      .then((res) => {
        if (res?.data?.data) {
          setPrices(res?.data?.data?.prices);
          setLabels(res?.data?.data?.timeArr);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getConversionRates();
  }, []);
  // useEffect(() => {
  //   if (
  //     conversionRateMLD &&
  //     conversionRateLord &&
  //     conversionRateMatic &&
  //     conversionRateUSDT
  //   ) {
  //     // JSON data containing NFT transfers
  //     // const nftData = [
  //     //   // Your data here...
  //     // ];

  //     const sortedNftData = nftData.slice().sort((a, b) => {
  //       return a.args.timestamp - b.args.timestamp;
  //     });
  //     const getDateFromTimestamp = (timestamp) => {
  //       if (!timestamp) {
  //         return "";
  //       }
  //       const transactionDate = new Date(timestamp * 1000);
  //       const day = transactionDate.getDate();
  //       const month = transactionDate.getMonth() + 1;
  //       const year = transactionDate.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };
  //     console.log(nftData[0]?.args, "nftdatainsidegraph");
  //     // Extracting data for the chart
  //     const labelarr = sortedNftData.map((entry) =>
  //       getDateFromTimestamp(entry?.args?.["timestamp"])
  //     );
  //     const pricesarr = sortedNftData.map((entry) => {
  //       if (
  //         entry?.args?.["currency"] ==
  //         "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6"
  //       ) {
  //         return (
  //           entry?.args?.["price"] / (1000000000000000000 * conversionRateMLD)
  //         );
  //       } else if (
  //         entry?.args?.["currency"] ==
  //         "0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
  //       ) {
  //         return entry?.args?.["price"] / (1000000 * conversionRateUSDT);
  //       } else if (
  //         entry?.args?.["currency"] ==
  //         "0x32522357a30E2F5b685eE90014f63A47DF1F9577"
  //       ) {
  //         return (
  //           entry?.args?.["price"] / (1000000000000000000 * conversionRateLord)
  //         );
  //       } else {
  //         return (
  //           entry?.args?.["price"] / (1000000000000000000 * conversionRateMatic)
  //         );
  //       }
  //     });
  //     console.log(pricesarr, "pricesofusdandtoken");
  //     setPrices(pricesarr);
  //     setLabels(labelarr);
  //     // Creating the chart
  //   }
  // }, [
  //   nftData,
  //   conversionRateLord,
  //   conversionRateMLD,
  //   conversionRateMatic,
  //   conversionRateUSDT,
  // ]); // Empty dependency array to run the effect only once on mount
  useEffect(() => {
    const ctx = document.getElementById("myChart").getContext("2d");
    const myChart = new Chart(ctx, {
      height: "auto",
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            label: "NFT Prices Over Time",
            data: prices,
            borderColor: "rgb(75, 192, 192)",
            tension: 0.1,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
            font: {
              size: 20,
            },
            title: {
              display: true,
              text: "Price ( USD )",
              font: {
                size: 20,
              },
              padding: {
                right: 50,
              },
            },
          },
          x: {
            title: {
              display: true,
              // text: "Date",
            },
          },
        },
        plugins: {
          legend: {
            display: false, // Hide the legend
          },
        },
      },
    });

    // Cleanup function to destroy the chart when component unmounts
    return () => {
      myChart.destroy();
    };
  }, [labels, prices]);
  return <canvas id="myChart" width="100" height="50"></canvas>;
};

export default ActivityTableGraph;
